import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { RHFTextField } from "../../components/hook-form";
import FormProvider from "../../components/hook-form/FormProvider";
import RHFJoditEditor from "../../components/hook-form/RHFJoditEditor";
import { Upload } from "../../components/upload";
import {
  createTestimonials,
  updateTestimonial,
} from "../../redux/slices/testimonialSlice";

const TestimonialForm = ({ handleClose, data, isEdit = false }) => {
  // TODO: hooks

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [image, setImage] = useState(null);

  // TODO: get the data from slice

  const createTestimonialsLoading = useSelector(
    (state) => state.testimonial.isLoading
  );

  const Schema = Yup.object().shape({
    title: Yup.string().required("Testimonial title is required"),
    name: Yup.string().required("Testimonial name is required"),
    content: Yup.string().required("Testimonial content is required"),
  });

  const defaultValues = useMemo(
    () => ({
      title: data?.title || "",
      name: data?.name || "",

      content: data?.content || "",
      image: data?.image || "",
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const { handleSubmit } = methods;

  // ======

  // TODO: functions

  // TODO: handle upload image
  const handleDropImage = useCallback((acceptedFiles) => {
    const newFile = acceptedFiles[0];
    if (newFile) {
      setImage(
        Object.assign(newFile, {
          preview: URL.createObjectURL(newFile),
        })
      );
      setImage(acceptedFiles[0]);
    }
  }, []);

  const onCreateTestimonials = (values) => {
    delete values.image;

    // TODO: dispatch the action to create a testimonial
    const formData = new FormData();

    formData.append("name", values.name);
    formData.append("title", values.title);

    formData.append("content", values.content);

    image && formData.append("image", image);

    dispatch(
      createTestimonials({ data: formData, enqueueSnackbar, handleClose })
    );
  };

  const onUpdateTestimonial = async (values) => {
    const formData = new FormData();

    delete values.image;

    // TODO: dispatch the action to create a testimonial

    formData.append("name", values.name);
    formData.append("title", values.title);

    formData.append("content", values.content);

    if (image) {
      formData.append("image", image);
    }
    await dispatch(
      updateTestimonial({
        data: formData,
        enqueueSnackbar,
        handleClose,
        id: data?.id,
      })
    );
  };

  // ======

  // TODO: console.logs

  return (
    <Box p={3}>
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(
          isEdit ? onUpdateTestimonial : onCreateTestimonials
        )}
      >
        <Stack flexDirection={"row"} justifyContent={"center"} mb={2}></Stack>
        <Box
          rowGap={3}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(1, 1fr)",
          }}
        >
          <RHFTextField name={"name"} label={"Name *"} />

          <RHFTextField name={"title"} label={"Title *"} />
        </Box>

        <Box mt={3}>
          <p className="mb-3">Testimonial description *</p>
          <RHFJoditEditor name={"content"} />
        </Box>

        <Box mt={3}>
          <Upload
            isAvatar={false}
            text={"Upload image"}
            file={image || defaultValues.image}
            name="image"
            accept="image/*"
            maxSize={1}
            onDrop={handleDropImage}
          />
        </Box>

        <Stack mt={2} alignItems={"end"}>
          <LoadingButton
            loading={createTestimonialsLoading}
            disabled={createTestimonialsLoading}
            type="submit"
            variant="contained"
            className="!bg-primary w-fit"
          >
            {isEdit ? "Update Testimonial" : "Create Testimonial"}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default TestimonialForm;
